var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "countries-latLng-components-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c("div", { staticStyle: { position: "relative", height: "95%" } }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { inline: true, model: _vm.form } },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.addCity },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "區域", size: "mini" } },
                  [
                    _vm.regionsSource
                      ? _c(
                          "el-select",
                          {
                            staticStyle: { width: "100px" },
                            attrs: {
                              "value-key": "key",
                              placeholder: "區域",
                              size: "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectedRegion(_vm.form)
                              },
                            },
                            model: {
                              value: _vm.form.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "region", $$v)
                              },
                              expression: "form.region",
                            },
                          },
                          _vm._l(_vm.regionsSource, function (c, ind) {
                            return _c("el-option", {
                              key: ind,
                              attrs: { label: c.val, value: c.key },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "國家", size: "mini" } },
                  [
                    _vm.form.countries
                      ? _c(
                          "el-select",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.form.countriesLoading,
                                expression: "form.countriesLoading",
                              },
                            ],
                            staticStyle: { width: "200px" },
                            attrs: {
                              filterable: "",
                              placeholder: "國家",
                              "value-key": "code",
                              size: "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectedCountry(_vm.form)
                              },
                            },
                            model: {
                              value: _vm.form.country,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "country", $$v)
                              },
                              expression: "form.country",
                            },
                          },
                          _vm._l(_vm.form.countries, function (c, ind) {
                            return _c("el-option", {
                              key: ind,
                              attrs: { label: c.chtName, value: c },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("el-switch", {
                      staticStyle: { display: "block" },
                      attrs: {
                        "active-value": true,
                        "inactive-value": false,
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                        "active-text": "開啟編輯",
                        "inactive-text": "關閉編輯",
                      },
                      model: {
                        value: _vm.mode,
                        callback: function ($$v) {
                          _vm.mode = $$v
                        },
                        expression: "mode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("el-button", {
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        size: "mini",
                        loading: _vm.listLoading,
                        type: "success",
                        icon: "el-icon-refresh-left",
                        circle: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refresh()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("el-alert", {
              staticStyle: { margin: "10px" },
              attrs: {
                title:
                  "1，城市代碼：請輸入英文，單字間隔可輸入空白。2，城市名稱：不限中英文。",
                type: "info",
                effect: "dark",
                closable: false,
              },
            }),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                attrs: {
                  size: "mini",
                  data: _vm.form.cities,
                  border: "",
                  fit: "",
                  "highlight-current-row": "",
                  height: "500px",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    label: "城市代碼",
                    width: "180",
                    prop: "label",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            attrs: { size: "mini", disabled: !_vm.mode },
                            model: {
                              value: scope.row.code,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "code", $$v)
                              },
                              expression: "scope.row.code",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "城市名稱",
                    width: "150",
                    prop: "label",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            attrs: { size: "mini", disabled: !_vm.mode },
                            model: {
                              value: scope.row.chtName,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "chtName", $$v)
                              },
                              expression: "scope.row.chtName",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    label: "經緯度",
                    width: "600",
                    prop: "label",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form",
                            { attrs: { inline: true } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "北緯(lat)" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "mini",
                                      disabled: !_vm.mode,
                                    },
                                    model: {
                                      value: scope.row.lat,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "lat", $$v)
                                      },
                                      expression: "scope.row.lat",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "東經(lng)" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "mini",
                                      disabled: !_vm.mode,
                                    },
                                    model: {
                                      value: scope.row.lng,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "lng", $$v)
                                      },
                                      expression: "scope.row.lng",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "設定", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.mode
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "success", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setCity(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("設定")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteCity(scope.row)
                                },
                              },
                            },
                            [_vm._v("刪除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }